// frontend/src/hooks/useAnalysis.ts

import { useState, useEffect, useCallback } from 'react';
import { AnalysisService } from '../services/analysis.service';
import { useAuth } from '../contexts/AuthContext';

export const useAnalysis = () => {
  const { selectedTraceId } = useAuth();

  const [datasets, setDatasets] = useState<any[]>([]);
  const [selectedDataset, setSelectedDataset] = useState<any | null>(null);
  const [analysis, setAnalysis] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const listDatasets = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await AnalysisService.listDatasets();
      setDatasets(data);
    } catch (err: any) {
      setError(err.response?.data?.error || err.message || 'Erro ao listar datasets');
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeDataset = useCallback(async (id: number) => {
    try {
      setLoading(true);
      setError(null);
      const data = await AnalysisService.analyzeDataset(id);
      setAnalysis(data);
      
      const dataset = datasets.find(d => d.id === id);
      if (dataset) {
        setSelectedDataset(dataset);
      }
    } catch (err: any) {
      setError(err.response?.data?.error || err.message || 'Erro ao analisar dataset');
    } finally {
      setLoading(false);
    }
  }, [datasets]);

  const selectDataset = useCallback((dataset: any) => {
    setSelectedDataset(dataset);
    analyzeDataset(dataset.id);
  }, [analyzeDataset]);

  // Carrega a lista ao montar
  useEffect(() => {
    listDatasets();
  }, [listDatasets]);

  // Se há trace selecionado, analisa automaticamente o dataset correspondente
  useEffect(() => {
    if (!selectedTraceId) return;
    if (datasets.length === 0) return;
    if (analysis?.trace_id === selectedTraceId) return; // já está carregado

    const match = datasets.find(d => d.trace_id === selectedTraceId);
    if (match) {
      setSelectedDataset(match);
      analyzeDataset(match.id);
    }
  }, [selectedTraceId, datasets, analysis, analyzeDataset]);

  return {
    datasets,
    selectedDataset,
    analysis,
    loading,
    error,
    listDatasets,
    analyzeDataset,
    selectDataset,
  };
};